export default "__VITE_PUBLIC_ASSET__ba8e733b__"